export default {
  lookups: state => state.lookups,
  groups: state => state.groups,
  timeZones: state => state.timeZones,
  countries: state => state.countries,
  stateProvinces: state => state.stateProvinces,
  languages: state => state.languages
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/getters.js